/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface DownloadArquivoSolicitacaoRequest {
  idArquivo: string;
  onSuccess: (arquivo: ArquivoSolicitacao) => void;
}

export interface ArquivoSolicitacao {
  id: string;
  caminho: string;
  fileName: string;
  originalFileName: string;
}

interface State {
  isRequesting: string[];
  errors: string[];
}

const initialState: State = {
  isRequesting: [],
  errors: []
};

const downloadArquivoSolicitacaoSlice = createSlice({
  name: "licenciamentourbano@downloadArquivoSolicitacao",
  initialState,
  reducers: {
    downloadArquivoSolicitacao: (
      state,
      action: PayloadAction<DownloadArquivoSolicitacaoRequest>
    ): void => {
      state.isRequesting = [...state.isRequesting, action.payload.idArquivo];
      state.errors = [];
    },
    downloadArquivoSolicitacaoSuccess: (
      state,
      action: PayloadAction<ArquivoSolicitacao>
    ): void => {
      state.isRequesting = state.isRequesting.filter(
        (x) => x != action.payload.id
      );
    },
    downloadArquivoSolicitacaoFailed: (
      state,
      action: PayloadAction<{ id: string; error: string[] }>
    ): void => {
      state.isRequesting = state.isRequesting.filter(
        (x) => x != action.payload.id
      );
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: DownloadArquivoSolicitacaoRequest;
}) {
  const { idArquivo, onSuccess } = params.payload;
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/licenciamentourbano/arquivo-solicitacao/${idArquivo}`
    );

    const { data } = response;
    onSuccess(data);

    yield put(downloadArquivoSolicitacaoSuccess(data));
  } catch (error) {
    yield put(
      downloadArquivoSolicitacaoFailed({
        id: params.payload.idArquivo,
        error: formatError(error)
      })
    );
  }
}

export const {
  downloadArquivoSolicitacao,
  downloadArquivoSolicitacaoSuccess,
  downloadArquivoSolicitacaoFailed
} = downloadArquivoSolicitacaoSlice.actions;

export const { reducer } = downloadArquivoSolicitacaoSlice;

export const saga = takeLatest(downloadArquivoSolicitacao.type, sagaFunction);
